// // utils/printUtils.js
// import axios from "axios";

// export const printData = async (
//   data,
//   api,
//   method,
//   params = null,
//   vm = null
// ) => {
//   try {
//     if (vm && vm.$loading) vm.$loading.start();

//     // Construire l'URL API
//     let apiUrl = api;
//     if (method.toUpperCase() === "GET" && params) {
//       apiUrl += `/${params}`;
//     }

//     // Configuration Axios
//     const config = {
//       responseType: "json",
//     };

//     let response;

//     if (method.toUpperCase() === "GET") {
//       response = await axios.get(apiUrl, config);
//     } else {
//       response = await axios.post(apiUrl, data, config); // ✅ data séparé
//     }

//     // Convertir la réponse base64 en PDF
//     const binaryData = atob(response.data.output);
//     const bytes = new Uint8Array(binaryData.length);
//     for (let i = 0; i < binaryData.length; i++) {
//       bytes[i] = binaryData.charCodeAt(i);
//     }

//     const blob = new Blob([bytes], { type: "application/pdf" });
//     const downloadUrl = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = downloadUrl;
//     link.setAttribute("download", response.data.filename || "rapport.pdf");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     if (vm && vm.$toast)
//       vm.$toast.success("Téléchargement terminé avec succès !");
//   } catch (error) {
//     console.error(error);
//     if (vm && vm.$toast)
//       vm.$toast.error("Une erreur est survenue lors de l'impression.");
//   } finally {
//     if (vm && vm.$loading) vm.$loading.stop();
//   }
// };
// utils/printUtils.js
import axios from "axios";
import Vue from "vue";

export const printData = async (data, api, method, params = null) => {
  Vue.prototype.$loading.start();

  try {
    // Construire l'URL API
    let apiUrl = api;
    if (method.toUpperCase() === "GET" && params) {
      apiUrl += `/${params}`;
    }

    // Configuration Axios
    const config = {
      responseType: "json",
    };

    let response;

    if (method.toUpperCase() === "GET") {
      response = await axios.get(apiUrl, config);
    } else {
      response = await axios.post(apiUrl, data, config);
    }

    // Convertir la réponse base64 en PDF
    const binaryData = atob(response.data.output);
    const bytes = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      bytes[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", response.data.filename || "rapport.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    Vue.prototype.$toast.success("Téléchargement terminé avec succès !");
  } catch (error) {
    console.error("Print Error:", error);

    const errorMessage =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : "Une erreur est survenue lors de l'impression.";

    Vue.prototype.$toast.error(errorMessage);
    throw error;
  } finally {
    Vue.prototype.$loading.stop();
  }
};
